import cx from 'classnames';
import { withErrorBoundary } from '@/ErrorBoundary';
import {
  TileData,
  TileDataContextProvider,
  useTileDataContext
} from '~/contexts/TileDataContext';
import FirstRow from './FirstRow';
import { useHasDealTag } from './helpers/ResultTile.helpers';
import PricingAndTerms from './PricingAndTerms';
import ShippingAndGetItBy from './ShippingAndGetItBy/ShippingAndGetItBy';
import SkeletonTile from './SkeletonTile/SkeletonTile';
import { DealTags } from './Tags';
import TileContainer from './TileContainer';
import VehicleYMMTM from './VehicleYMMTM';

const ResultTile = () => {
  const { tileData } = useTileDataContext();
  const hasTag = useHasDealTag(tileData);

  return (
    <TileContainer>
      <FirstRow />
      <div
        className={cx(
          'gap-y-12 grid grid-cols-1 px-16 py-12 m:grid-rows-[20px_48px_1fr_auto]',
          hasTag
            ? 'grid-rows-[20px_48px_1fr_auto]'
            : 'grid-rows-[48px_1fr_auto]'
        )}
      >
        <DealTags />
        <VehicleYMMTM />
        <PricingAndTerms />
        <ShippingAndGetItBy />
      </div>
    </TileContainer>
  );
};

interface ResultTileWithProviderProps {
  tileData?: TileData;
}

const ResultTileWithProvider = ({ tileData }: ResultTileWithProviderProps) => {
  return tileData ? (
    <TileDataContextProvider tileData={tileData}>
      <ResultTile />
    </TileDataContextProvider>
  ) : (
    <SkeletonTile />
  );
};

export default withErrorBoundary(ResultTileWithProvider);
